<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>contacts</md-icon>
              </div>
              <h4 class="title">Passwort zurücksetzen</h4>
              <h4 v-if="!codeForm">Bitte gib deine E-Mail ein</h4>
              <h4 v-if="codeForm">
                Wir haben dir einen Sicherheitscode geschickt an
                {{ email }}. Bitte gib ihn hier ein
              </h4>
              <h4 v-if="resetForm">Neues Passwort</h4>
            </md-card-header>

            <md-card-content v-if="!codeForm">
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>E-Mail</label>
                  <md-input
                    v-model="email"
                    type="email"
                    autocomplete="email"
                  ></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </md-card-content>

            <md-card-content v-if="codeForm">
              <ValidationProvider name="code">
                <md-field>
                  <label>Code</label>
                  <md-input v-model="code" type="text"></md-input>
                </md-field>
              </ValidationProvider>
              <ValidationProvider
                name="password"
                rules="required|confirmed:confirmation|min:5"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Passwort</label>
                  <md-input v-model="password" type="password"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                vid="confirmation"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Passwort wiederholen</label>
                  <md-input v-model="confirmation" type="password"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </md-card-content>

            <md-card-actions>
              <md-button
                class="md-primary"
                v-if="codeForm"
                @click.prevent="codeForm = false"
                >Zurück</md-button
              >
              <md-button type="submit" class="md-success" v-if="!codeForm"
                >Abschicken</md-button
              >
              <md-button type="submit" class="md-success" v-if="codeForm"
                >Fortfahren</md-button
              >
            </md-card-actions>
          </md-card>
        </form>
        <div v-if="!codeForm && !resetForm">
          <p>Ist dir dein Passwort wieder eingefallen?</p>
          <router-link to="/Login"
            ><md-button class="md-primary">Login</md-button></router-link
          >
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);

export default {
  data() {
    return {
      email: null,
      codeForm: false,
      code: null,
      resetForm: false,
      password: null,
      confirmation: null
    };
  },
  methods: {
    submit(val) {
      if (!this.codeForm && !this.resetForm) {
        this.$store
          .dispatch("requestNewPassword", this.email)
          .then(res => {
            this.codeForm = true;
            return;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
            return;
          });
      }
      if (this.code && !this.resetForm) {
        this.$store
          .dispatch("checkPasswordCode", {
            code: this.code,
            password: this.password
          })
          .then(res => {
            // Send user to Dashboard afer Successful Login
            this.$router.push("/login");
            // Notify the login
            this.$notify({
              timeout: 5000,
              message: "Dein Kennwort wurde erfolreich geändert!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            return;
          })
          .catch(err => {
            // this.codeForm = false;
            this.code = null;
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
        return;
      }
    }
  }
};
</script>

<style sccoped></style>
